import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress, Box } from "@mui/material";
import {
  getExercisePrescription,
  selectPrescription,
  selectOverrideRate,
} from "../../redux/slices/exerciseSlice";
import PrescriptionEvalCard from "./PrescriptionEvalCard";

// doc 29, Phase 9 — P9.9. Connected wrapper: fetches the contract-v2 prefill
// for a movement (source + reasoning + per-set targets), derives the
// override-rate via the slice selector, and hands both to the pure card.
const PrescriptionEval = ({ exerciseName }) => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.authSlice);
  const prescription = useSelector(selectPrescription(exerciseName));
  const overrideRate = useSelector(selectOverrideRate(exerciseName));
  const loading = useSelector((state) => state.exerciseSlice.prescriptionLoading);

  useEffect(() => {
    if (token && exerciseName && !prescription) {
      dispatch(getExercisePrescription({ token, exercise_name: exerciseName }));
    }
  }, [dispatch, token, exerciseName, prescription]);

  if (loading && !prescription) {
    return (
      <Box display="flex" justifyContent="center" p={2}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  return (
    <PrescriptionEvalCard
      exerciseName={exerciseName}
      prescription={prescription}
      overrideRate={overrideRate}
    />
  );
};

export default PrescriptionEval;
